import { render, staticRenderFns } from "./CallUs.vue?vue&type=template&id=32412594&scoped=true&"
import script from "./CallUs.vue?vue&type=script&lang=js&"
export * from "./CallUs.vue?vue&type=script&lang=js&"
import style0 from "./CallUs.vue?vue&type=style&index=0&id=32412594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32412594",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VSheet})
